import { defineStore } from "pinia";

export const useAuthStore = defineStore("auth", {
  state: () => ({
    emailVerified: true, // assume true until backend says otherwise
  }),
  actions: {
    setEmailVerified(value) {
      this.emailVerified = value;
    },
  },
});
